import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Samoa: Country = {
    identifier: "Samoa",
    name: "Samoa",
    countryCode: "WS",
    group: CountryGroup.OCEANIA,
    isUNMember: true,
    flag: "🇼🇸",
    svgPath: "m 1001.5787,500.8144 0.314,0.271 0.126,0.359 -0.136,0.343 -0.297,-0.084 -0.432,0.073 -0.144,-0.025 -0.345,-0.421 -0.24,-0.189 -0.096,-0.178 0.305,0.02 0.446,-0.118 0.499,-0.051 z m 2.469,1.668 -0.77,0.002 -0.381,-0.13 -0.135,-10e-4 -0.326,-0.272 -0.05,-0.143 0.171,-0.094 0.355,-0.049 0.714,0.207 0.108,0.184 0.164,0.02 0.128,0.08 0.033,0.129 -0.011,0.067 z",
}
